module.exports = __webpack_public_path__ + "08_face.9058e924.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer1/08_face.png
// module id = UyuU
// module chunks = 0